import React, { useState } from 'react'
import './chatAgent.css'
import ChatHistory from './ChatHistoryAgent'
import OneChat from './OneChatAgent'
import Nav from '../Nav/Nav'
import face2 from '../imgs/face2.jpg';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { useNavigate } from 'react-router-dom'
import AddPhotoAlternateTwoToneIcon from '@mui/icons-material/AddPhotoAlternateTwoTone';

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";


const ChatAgent = () => {
    const[paypal,setPaypal]=useState(false);


    const[sender,setSender]=useState("Annie S"); //current user
    const[selectChatId,setSelectedChatId]=useState("");
    const[openedWhoseChat,setOpenedWhoseChat]=useState("Open a chat to view conversation");//opened whose chat's? 
    const[openedWhoseImg,setOpenedWhoseImg]=useState("logo");//opened whose chat's img? 
    function ChatSetOnClick([idd,seconduser,imgg]){
        setSelectedChatId(idd);
        setOpenedWhoseChat(seconduser);
        setOpenedWhoseImg(imgg);
    }

    const navigate=useNavigate();
    function GoToEscrow(){
        navigate("/escrow");
    }

  return (
    <div>
        <Nav />
        <div className="Chat">
            <div className="ChatLeft">
                <div className="LeftTop">
                    <img src={face2} className='LeftTopImg'></img>
                    <div className="LeftName">
                        Annie S
                        <button>Edit your profile</button>
                    </div>
                </div>
                <div className="LeftCenter">
                    <input placeholder='Search'/>
                </div>
                <div className="LeftBottom">
                    {ChatHistory.map((oneChatHistory)=>(
                        <div style={{cursor:"pointer"}} 
                             className="oneChatHist" 
                             onClick={(e)=>{ChatSetOnClick([oneChatHistory.id,oneChatHistory.name,oneChatHistory.img])}} 
                             value={oneChatHistory.id} key={oneChatHistory.id}>

                            <img src={require("../imgs/"+oneChatHistory.img+".png")} className='LeftBottomImgs'/>
                            <div className="LeftBottomInfo">
                                <div>{oneChatHistory.name}</div>
                                <div>{oneChatHistory.msg}</div>
                            </div>
                            <div className="LeftBottomTime">
                                {oneChatHistory.time}
                                <div className="LeftBottomUnread">1</div>
                            </div>
                            
                            
                        </div>
                        )
                    )}
                </div>
            </div>

            <div className="ChatRight">
                <div className="RightTop">
                    <img src={require("../imgs/"+openedWhoseImg+".png")} className="RightTopImg"></img>
                    <div className="RightName">
                        {openedWhoseChat}
                        {openedWhoseChat!='Open a chat to view conversation' ?(
                            <>
                                <button>View profile</button>
                            </>
                        ):
                        (
                            <></>
                        )}
                    </div>
                </div>
                <div className="RightCenter">
                    {OneChat.map((oneChat)=>(
                        < >
                                {oneChat.chatId===selectChatId 
                                ?
                                    ((oneChat.sender===sender)
                                    ?(
                                        <div className="MsgRight">{oneChat.msg}</div>
                                    )
                                    :(
                                        <div className="MsgLeft">{oneChat.msg}</div>
                                    ))
                                :
                                (<></>)
                                }
                        </>
                            )
                        )}

                </div>
                <div className="RightBottom">
                    <input className="RightBottomWrite" placeholder='Write something'></input>
                    <button className='RightBottomSendPhoto'>
                      <label className="custom-file-upload">
                        <input type="file" className='PhotoUpload'/>
                        <AddPhotoAlternateTwoToneIcon/>
                     </label>
                    </button>                   
                    <button className='RightBottomSend'><SendRoundedIcon/></button>


                    <div className="PayNow">
                        <button onClick={()=>{setPaypal(!paypal)}} className='RightBottomPay' >PAY NOW</button>
                        {paypal &&
                        <div style={{margin:"10px", backgroundColor:"transparent",padding:"20px"}} className='RightBottomPayPopUp'>
                        <PayPalScriptProvider
                        options={{ "client-id": "AQEaRkq0IyHNXro2-bw7dZ5Fm9XWo7YBHdr_huc3r2s6vuIPWNSXBAZFzoih--dzxSlfzy-iCz_rKwmZ" }}>
                            <PayPalButtons
                            createOrder={(data, actions) => {
                                return actions.order.create({
                                purchase_units: [
                                    {
                                    amount: {
                                        value: "13.99",
                                    },
                                    },
                                ],
                                });
                            }}
                            onApprove={async (data, actions) => {
                                const details = await actions.order.capture();
                                const name = details.payer.name.given_name;
                                alert("Transaction completed by " + name);
                            }}
                            />
                        </PayPalScriptProvider>
                        </div>
                        }
                    </div>


                </div>
            </div>
        </div>
    </div>
  )
}

export default ChatAgent